import { render, staticRenderFns } from "./GoalsByAdmin.vue?vue&type=template&id=256e82c0"
import script from "./GoalsByAdmin.vue?vue&type=script&lang=js"
export * from "./GoalsByAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports